import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import Steps, { Step } from 'rc-steps';
import 'rc-steps/assets/index.css';
import hasFormstackHandoff from '../lib/formstack/hasFormstackHandoff';

const ONE_LINE_STEP = { position: 'relative !important', top: '6px !important' };

const steps = [
  ['Account', 'Setup'],
  ['Download', 'Application'],
  ['Finished', 'Application'],
];

const APPLICATION_STEP = 1;

// FR-001 — the embedded experience never produces a PDF, so the step cannot ask the applicant
// to download one. Returns a new array: `steps` is module state shared by all three entity
// pages, so mutating it would relabel the bar for every later render in the same page load.
const EMBEDDED_APPLICATION_STEP = ['Fill out', 'Application'];

const stepsFor = showEmbeddedExperience => (showEmbeddedExperience
  ? steps.map((step, index) => (index === APPLICATION_STEP ? EMBEDDED_APPLICATION_STEP : step))
  : steps);

const currentStep = (location) => {
  const path = location.location.pathname.substring(1);
  return parseInt(location.routes[0].childRoutes.find(r => r.path === path).step, 10);
};

const title = (step) => {
  return <div><span>{step[0]}</span><span>{step[1]}</span></div>;
};

const progressBarSteps = showEmbeddedExperience => stepsFor(showEmbeddedExperience).map((step, index) => {
  if (index !== 2) {
    return <Step key={index.toString()} title={title(step)} style={ONE_LINE_STEP} />;
  }
  return <Step key={index.toString()} title={title(step)} />;
});


export const EntityProgressBar = (props) => {
  const { showEmbeddedExperience } = props;
  return (
    <section id="progressBar">
      <div className="fitv_element container-fluid">
        <div className="container notranslate progress-steps-container">
          <div className="row">
            <div className=" col col-md-12 col-lg-12">
              <Steps current={currentStep(props)}>
                {progressBarSteps(showEmbeddedExperience)}
              </Steps>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

EntityProgressBar.propTypes = {
  showEmbeddedExperience: PropTypes.bool,
};

export function mapStateToProps(state) {
  return { showEmbeddedExperience: hasFormstackHandoff(state) };
}

export default withRouter(connect(mapStateToProps)(EntityProgressBar));
